<template>
  <div class="el-card  pd20 special">
    <!-- 返回 -->
    <div class="cancel-box">
      <el-button type="info" icon="el-icon-arrow-left" @click="$router.go(-1)" size="medium">返回联报列表</el-button>
    </div>
    <el-divider></el-divider>
    <!-- form -->
    <el-form :model="form" :rules="rules" ref="form">
      <!--  -->
      <el-form-item label="联报类型" prop="type" :label-width="formLabelWidth">
        <el-select v-model="form.type" placeholder="请选择联报类型" @change="change_config(form.type)">
          <el-option v-for="(item,index) in type_list" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!--  -->
      <div v-for="(item,index) in form.config" :key="index">
        <el-form-item :label="`课程${index+1}`" :prop="`config[${index}].id`" :label-width="formLabelWidth" :rules="{required: true,
            message: '请选择课程名称',
            trigger: ['blur','change']}">
          <el-select v-model="item.id" placeholder="请选择课程名称">
            <el-option v-for="(itm,idx) in course" :key="idx" :label="itm.name" :value="itm.id"></el-option>
          </el-select>
        </el-form-item>
        <!--  -->
        <el-form-item :label="`课程${index+1}佣金`" placeholder="请填写转介人佣金" :prop="`config[${index}].commission`" :rules="{required: true,
            message: '请填写转介人佣金',
            trigger: 'blur'}" :label-width="formLabelWidth">
          <el-input v-model="item.commission" class="price"></el-input>
        </el-form-item>
      </div>
      <!--  -->
      <el-form-item label="联报优惠" prop="favorable" :label-width="formLabelWidth">
        <el-input v-model="form.favorable" class="price"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="退款规则" prop="refund_rule" placeholder="请填写退款金额，英文逗号隔开" :label-width="formLabelWidth">
        <el-input v-model="form.refund_rule" class="price"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item label="课程状态" prop="state" :label-width="formLabelWidth">
        <el-radio-group v-model="form.state">
          <el-radio :label="0">开启</el-radio>
          <el-radio :label="1">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--  -->
      <el-form-item :label-width="formLabelWidth">
        <el-button type="primary" @click="submitForm('form')">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  joint_course_edit,
  joint_course_editdo
} from "@/api/course";
export default {
  data() {
      return {
        formLabelWidth: '120px',
        course: [],
        form: {
          type: 0,
          state: null,
          favorable: null,
          config: [{
            id: null,
            commission: ''
          }, {
            id: null,
            commission: ''
          }],
          refund_rule: null
        },
        type_list: [{
          id: 0,
          name: '2门'
        }, {
          id: 1,
          name: '3门'
        }, {
          id: 2,
          name: '4门'
        }, {
          id: 3,
          name: '5门'
        }],
        //这是一个验证规则
        rules: {
          type: [{
            required: true, //是否必填
            message: '请选择课程', //错误提示信息
            trigger: 'blur' //检验方式（blur为鼠标点击其他地方，）
          }],
          favorable: [{
            required: true,
            message: '请输入联报优惠',
            trigger: 'blur'
          }],
          state: [{
            required: true,
            message: '请选择课程状态',
            trigger: 'blur'
          }]
        }
      }
    },
    methods: {
      // 更改联报类型
      change_config(num) {
        let num_count = num + 2;
        let choose = {
          id: '',
          commission: ''
        };
        let config_lg = this.form.config.length;
        if (num_count > config_lg) {
          for (var i = 0; i < num_count - config_lg; i++) {
            this.form.config.push(choose);
          }
        } else if (num_count < config_lg) {
          this.form.config.splice(-(config_lg - 1), config_lg - num_count);
        }

      },
      // 提交数据
      save() {
        if(this.$route.query.id) {
            this.form.id=this.$route.query.id
        }

        joint_course_editdo(this.form).then((data) => {
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.$notify({
            title: '成功',
            message: '提交成功！',
            type: 'success'
          });
          setTimeout(() => {
              this.$router.push('/main/course_quote_list');
          },300)

        });
      },
      //
      submitForm(formName) {
        const el = this.$refs[formName];
        el.validate((valid) => {
          if (valid) {
            this.save();
          } else {
            this.$message.warning('请检查数据是否为空？');
            return false;
          }
        });
      },
      pullData() {
        joint_course_edit({
            id: this.$route.query.id ? this.$route.query.id : 0
          })
          .then((data) => {
            let is_object = Object.prototype.toString.call(data.list.data) === '[object Object]';
            this.form = is_object ? data.list.data : this.form;
            this.course = data.list.course;
          });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.special {
  .el-input,
  .el-textarea {
    width: 775px;
  }
  .price {
    width: 217px;
    margin-right: 20px;
  }
}

.cancel-box {
  margin-bottom: 20px;
}

.up-image {
  margin: 20px auto auto;
  width: 187.5px;
  text-align: center;
  border-radius: 8px;
  .error {
    border-radius: 8px;
    background-color: rgba($color: #eeeeee, $alpha: .5);
  }
}

.auto-hour {
  margin-right: 20px;
  border-radius: 4px;
  padding: 8px 0px;
  padding-left: 15px;
}
</style>
<style lang="scss">
.special .el-select .el-input.is-disabled .el-input__inner {
  background: rgba(0, 0, 0, 0.6)!important;
}
</style>
